import api from './api';
import { ApiResponse, Pagination } from '../types';
import { LetterTemplateV2, LetterTemplateV2FormData } from '../types/letters';

export interface LetterTemplateListResponse {
  templates: LetterTemplateV2[];
  pagination: Pagination;
}

const buildQueryString = (params: Record<string, string | number | undefined | null>): string => {
  const search = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== '') search.append(k, String(v));
  }
  return search.toString();
};

export const getLetterTemplates = async (params?: {
  schoolId?: string;
  categoryId?: string;
  page?: number;
  limit?: number;
}): Promise<LetterTemplateListResponse> => {
  const qs = buildQueryString({
    schoolId: params?.schoolId,
    categoryId: params?.categoryId,
    page: params?.page,
    limit: params?.limit,
  });
  const res = await api.get<ApiResponse<LetterTemplateListResponse>>(`/letter-templates?${qs}`);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

export const getLetterTemplateById = async (id: string): Promise<LetterTemplateV2> => {
  const res = await api.get<ApiResponse<LetterTemplateV2>>(`/letter-templates/${id}`);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

export const createLetterTemplate = async (data: LetterTemplateV2FormData & { schoolId?: string }): Promise<LetterTemplateV2> => {
  const res = await api.post<ApiResponse<LetterTemplateV2>>('/letter-templates', data);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

export const updateLetterTemplate = async (id: string, data: LetterTemplateV2FormData): Promise<LetterTemplateV2> => {
  const res = await api.put<ApiResponse<LetterTemplateV2>>(`/letter-templates/${id}`, data);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

export const deleteLetterTemplate = async (id: string): Promise<LetterTemplateV2> => {
  const res = await api.delete<ApiResponse<LetterTemplateV2>>(`/letter-templates/${id}`);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

const letterTemplateService = {
  getLetterTemplates,
  getLetterTemplateById,
  createLetterTemplate,
  updateLetterTemplate,
  deleteLetterTemplate,
};

export default letterTemplateService;
